import deleteIcon from "../../assets/design-revamp/delete-icon.svg";

const DeleteIcon = ({ style, onClick }) => {
  return (
    <>
      <div onClick={onClick}>
        <img
          className=""
          src={deleteIcon}
          alt=""
          style={{ ...style, width: "20px", height: "20px" }}
        />
      </div>
    </>
  );
};

export default DeleteIcon;
